import { PRIVATE_ADMIN } from "Shared/Routing/Application/Constants/PathsConstant";

export const PRIVATE_ADMIN_LIST_PERMISSIONS = PRIVATE_ADMIN + '/list-permissions';
export const PRIVATE_ADMIN_FORM_PERMISSION = PRIVATE_ADMIN + '/form-permission';